import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import { Photo } from "../../../components/media/Photo"
import HorizontalScroll, {
  HorizontalScrollItem,
} from "../../../components/HorizontalScroll"

const ProductItem = ({ product, onSelectProduct, media = [] }) => {
  var minPrice =
    product && product.pricing
      ? product.pricing.reduce((a, i) => {
          if (i.price != null) {
            return a == 0 ? i.price : Math.min(i.price, a)
          }
          return a
        }, 0)
      : 0

  return (
    <article className="rounded-2xl bg-[#F5FAFD] p-3 md:p-7 my-4">
      <div className="md:flex items-center justify-between">
        <div className="md:flex sm:mr-8">
          <div className="flex items-center mb-4 md:m-0">
            <div className="w-[69px] h-[69px] md:w-[88px] md:h-[88px]">
              {media.length > 0 && (
                <Photo media={media[0]} imgWidth={69 * 2} radius />
              )}
            </div>
            <div className="md:hidden ml-4">
              <Typography variant="h5" component="h4" gutterBottom>
                {product.name}
              </Typography>
            </div>
          </div>
          <div className="md:ml-4">
            <div className="hidden md:block">
              <Typography variant="h5" component="h4" gutterBottom>
                {product.name}
              </Typography>
            </div>
            {product.description && (
              <Typography
                dangerouslySetInnerHTML={{
                  __html: product.description,
                }}
                gutterBottom
              ></Typography>
            )}
          </div>
        </div>
        <div className="md:flex items-center">
          <div className="mb-2 md:m-0">
            <Typography variant="h6" component="div">
              cena od {minPrice} zł
            </Typography>
          </div>
          <div className="md:ml-4">
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => onSelectProduct(product)}
            >
              Wybierz
            </Button>
          </div>
        </div>
      </div>
    </article>
  )
}

export const VenueSectionProducts = ({ venue, onProductSelected }) => {
  // That should be filtered out by the server, but better to check again
  const notArchivedProducts =
    venue?.products?.filter((p: any) => !p.archivedAt) ?? []

  return (
    <section>
      <HorizontalScroll className="md:block">
        {notArchivedProducts.map((product) => {
          const productMedia = venue.media?.filter(
            (m: any) => m.productId == product.id
          )
          return (
            <HorizontalScrollItem key={product.id} className="w-full">
              <ProductItem
                product={product}
                media={productMedia}
                onSelectProduct={onProductSelected}
              />
            </HorizontalScrollItem>
          )
        })}
      </HorizontalScroll>
    </section>
  )
}
